import { identity } from 'ramda';
import React from 'react';

export const Footer = (props) => {
  const { className = '', children = null } = props;

  return (
    <footer className={['footer pSm-30 anchorParent', className].filter(identity).join(' ')}>
      {children}
      <div className="fontSm-13 App-footer anchorParent footer-links">
        <a
          className="anchor source-link"
          rel="noopener noreferrer"
          target="_blank"
          href="https://help.liaisonedu.com/Analytics/Privacy_Policy_and_Terms_of_Use/Terms_of_Use">
          Terms of Use
        </a>
        <a
          className="anchor source-link"
          rel="noopener noreferrer"
          target="_blank"
          href="https://help.liaisonedu.com/Analytics/Privacy_Policy_and_Terms_of_Use/Privacy_Policy">
          Privacy Policy
        </a>
        <a
          className="anchor source-link"
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.liaisonedu.com/508-compliance">
          Accessibility Statement
        </a>
      </div> 
    </footer>
  );
};

export default Footer;
